// extracted by mini-css-extract-plugin
export default {"footer":"Rodape_footer__vkuVt","footer__icons":"Rodape_footer__icons__v6sjS","footer__text":"Rodape_footer__text__0Ceu7","fab":"Rodape_fab__CZH1i"};